import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useFetchPosFlag } from "../../../../../../views/pages/manage/unAssigned/collectPayment/context/customHook";
import { initialForm } from "../../../../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { validatePaymentMode } from "../../../../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { useWizard } from "../../../../../../components/wizard/WizardContext";
import { useSaveDataToConfigValues } from "../../selectRefundReasonAndReceipt/utils";


export const RectifyRefundPaymentModeContext = createContext({});

export const useGetRectifyRefundPaymentModeContext = () => {
  return useContext(RectifyRefundPaymentModeContext);
}

export const RectifyRefundPaymentModeContextProvider = ({ children, ...props }) => {
    const {values} = useWizard();
    const {selectedStudent : studentBasicDetails , rectRefundStep2Data , rectRefundStep3Data} = values;

    const {selectedReceipt} = rectRefundStep2Data; 
    // debugger

    // const selectedReceipt =  receiptsData?.find(receipt => receipt?.receiptId === selectedReceiptId[0]);
    const amountToBePaid = selectedReceipt?.paymodeAmount ?? 0;
    const selectedChargesAmount = amountToBePaid;

//   const { psid } = useParams();

//   const [currentPageState, setCurrentPageState] = useState(PAGE_STATE.SELECT_PAYMENT_MODE);
//   const [currentStep, setCurrentStep] = useState(0);
//   const [studentChargesList, setStudentCharges] = useState({
//     loading: false,
//     REGULAR_CHARGES: [],
//     OTHER_CHARGES: []
//   })
//   const [selectedCharges, setSelectedCharges] = useState({
//     REGULAR_CHARGES: [],
//     OTHER_CHARGES: [],
//   });
//   const [selectionModel, setSelectionModel] = useState([]);
  const [state, setState] = useState('');

  //select payment mode states
  const [currentPaymentMode, setCurrentPaymentMode] = useState(rectRefundStep3Data?.currentPaymentMode);
  const [bankDropdown, setBankDropdown] = useState([]);
  const [paymentModeForm, setPaymentModeForm] = useState({...rectRefundStep3Data?.paymentModeForm , paidAmount : amountToBePaid}); //this paidAmount is autofilled in form on UI when we pass noAmountChange as true
  const [availablePosList, setAvailablePos] = useState([])
  const [bankMasterId, setBankMasterId] = useState({});
  const [balanceMode, setBalanceMode] = useState(rectRefundStep3Data?.balanceMode);
  const [loader, setloader] = useState(false);
  const [collectPayment, setCollectPayment] = useState(rectRefundStep3Data?.collectPayment);
  const [collectVoucherList, setCollectVoucherList] = useState(rectRefundStep3Data?.collectVoucherList);
  const [paymentModeIdLimitList, setPaymentModeIdLimitList] = useState(rectRefundStep3Data?.paymentModeIdLimitList);
  const [modifyPaymentModeData, setModifyPaymentModeData] = useState(rectRefundStep3Data?.modifyPaymentModeData);
  const [vouchersDialogOpen, setVouchersDialogOpen] = useState(true);
  const [totalUnpaidAmount, setTotalUnpaidAmount] = useState(rectRefundStep3Data?.totalUnpaidAmount);

  const totalCollectedAmount = [...collectPayment, ...collectVoucherList]?.reduce((acc, curr) => acc + (+curr.paidAmount), 0);
  const [balanceAmount, setBalanceAmount] = useState(amountToBePaid - totalCollectedAmount);


  //hooks and customHooks
//   const studentDetails1 = useGetStudentDetails({ psid });
//   const allActiveBusinessArea = useGetAllBusinessArea(true);
//   const roleId = useGetUserRoledId();

//   const studentBasicDetails = useMemo(() => {
//     const { businessArea: bu, buId, rollNumber, courseId, term, id: examOtherChargeId, examTimeCode } = selectedCharges['OTHER_CHARGES']?.[0] ?? {}
//     return {
//       ...(studentDetails1?.details ?? {}),
//       bu,
//       buId,
//       rollNumber,
//       courseId,
//       term,
//       examOtherChargeId,
//       examTimeCode
//     };

//   }, [studentDetails1, selectedCharges]);

//   useEffect(() => {
//     allActiveBusinessArea?.length > 0 && fetchExamChargesData();
//   }, [allActiveBusinessArea])

  const isOnlineModeEnabled = useFetchPosFlag(studentBasicDetails, setAvailablePos);

//   const {
//     totalBaseAmount,
//     totalConcessionAmount,
//     totalPayableAmount,
//     totalTaxes,
//     totalFinalPayable
//   } = useGetSelectedChargesTotals(selectedCharges);

//   const fetchExamChargesData = () => fetchExamCharges(psid, setStudentCharges, allActiveBusinessArea, setState);

  const paymentModeFormHandler = (key, value) => {
    setPaymentModeForm({ ...paymentModeForm, [key]: value });
  };

//   const landingPageDataLoading =
//     allActiveBusinessArea?.length === 0 ||
//     studentChargesList?.loading ||
//     studentDetails1?.loading;

  // const amountToBePaid = 500//imp
  // const selectedChargesAmount = 500;//imp
  // const totalCollectedAmount = [...collectPayment, ...collectVoucherList]?.reduce((acc, curr) => acc + (+curr.paidAmount), 0);

  const dataToSaveToConfig = {
    currentPaymentMode,
    paymentModeForm,
    // balanceAmount,
    balanceMode,
    collectPayment,
    collectVoucherList,
    paymentModeIdLimitList,
    modifyPaymentModeData,
    totalUnpaidAmount
  }

  useSaveDataToConfigValues(dataToSaveToConfig , "rectRefundStep3Data")

  return (
    <RectifyRefundPaymentModeContext.Provider
      value={{
        studentBasicDetails,
        // studentDetails1,
        // currentStep,
        // setCurrentStep,
        // currentPageState,
        // setCurrentPageState,
        state,
        setState,

        // studentChargesList,
        // selectedCharges,
        // setSelectedCharges,
        
        selectedChargesAmount,
        currentPaymentMode,
        setCurrentPaymentMode,
        bankDropdown,
        setBankDropdown,
        setPaymentModeForm,
        paymentModeForm,
        paymentModeFormHandler,
        // roleId,
        bankMasterId,
        setBankMasterId,
        balanceAmount,
        setBalanceAmount,
        balanceMode,
        setBalanceMode,
        loader,
        setloader,
        collectPayment,
        setCollectPayment,
        collectVoucherList,
        setCollectVoucherList,
        paymentModeIdLimitList,
        setPaymentModeIdLimitList,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        isOnlineModeEnabled,
        amountToBePaid,
        totalCollectedAmount,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        totalUnpaidAmount,
        setTotalUnpaidAmount,
        availablePosList,

        // fetchExamChargesData,
        // landingPageDataLoading,

        // selectionModel,
        // setSelectionModel,
        // totalBaseAmount,
        // totalConcessionAmount,
        // totalPayableAmount,
        // totalTaxes,
        // totalFinalPayable,

        //pseudo validation functions
        validatePaymentMode: (...args) => validatePaymentMode(...args, true),
        // validateSequencing,
        // reviewReceipt,

        disableAmountField : true,
        noAmountChange : true,
        ...props,
      }}
    >
      {children}
    </RectifyRefundPaymentModeContext.Provider>
  )
}